(function(){
'use strict';
 /*
   * SHRINE STICKY ADD TO CART - STANDALONE
   *
   * Standalone Sticky ATC functionality.
   * Does not depend on Shrine main.js.
   *
   * Visibility:
   * - Hidden at the very top
   * - Hidden while main ATC is visible
   * - Visible after main ATC leaves viewport
   * - Hidden at the very bottom of the page
   */


  /*
   * ---------------------------------------------------------
   * GET MAIN PRODUCT FORM
   * ---------------------------------------------------------
   */

  function getProductForm(sectionId) {

    return (
      document.querySelector(
        `product-form[data-section="${sectionId}"][data-main="true"]`
      ) ||

      document.querySelector(
        'product-form[data-main="true"]'
      ) ||

      document.querySelector(
        'product-form.main-product-form'
      )
    );
  }


  /*
   * ---------------------------------------------------------
   * GET SELECTED STICKY VARIANT
   * ---------------------------------------------------------
   */

  function getStickyVariant(sticky) {

    const variantData =
      sticky.querySelector(
        'script[type="application/json"]'
      );

    if (!variantData) {

      console.warn(
        'Sticky ATC: variant JSON not found.'
      );

      return null;
    }


    let variants;

    try {

      variants =
        JSON.parse(
          variantData.textContent
        );

    } catch (error) {

      console.error(
        'Sticky ATC: unable to read variant data.',
        error
      );

      return null;
    }


    if (!Array.isArray(variants)) {
      return null;
    }


    /*
     * -------------------------------------------------------
     * COMBINED VARIANT PICKER
     * -------------------------------------------------------
     */

    const combinedSelect =
      sticky.querySelector(
        'select.sticky-atc__variant-select'
      );


    if (combinedSelect) {

      const selected =
        combinedSelect.options[
          combinedSelect.selectedIndex
        ];


      const variantId =
        selected?.dataset.variantId;


      if (variantId) {

        return (
          variants.find(
            variant =>
              String(variant.id) ===
              String(variantId)
          ) || null
        );
      }
    }


    /*
     * -------------------------------------------------------
     * SEPARATE VARIANT PICKERS
     * -------------------------------------------------------
     */

    const separateSelects =
      Array.from(
        sticky.querySelectorAll(
          '.sticky-atc__picker--separate select'
        )
      );


    if (separateSelects.length) {

      const selectedOptions =
        separateSelects.map(
          select => select.value
        );


      return (
        variants.find(
          variant => {

            if (
              !Array.isArray(
                variant.options
              )
            ) {
              return false;
            }


            return variant.options.every(
              (option, index) =>
                String(option) ===
                String(
                  selectedOptions[index]
                )
            );
          }
        ) || null
      );
    }


    /*
     * -------------------------------------------------------
     * FALLBACK - MAIN PRODUCT FORM
     * -------------------------------------------------------
     */

    const mainForm =
      getProductForm(
        sticky.dataset.section
      );


    const variantInput =
      mainForm?.querySelector(
        'input[name="id"]'
      );


    if (variantInput?.value) {

      return (
        variants.find(
          variant =>
            String(variant.id) ===
            String(variantInput.value)
        ) || null
      );
    }


    /*
     * Final fallback.
     */

    return variants[0] || null;
  }


  /*
   * ---------------------------------------------------------
   * SYNC MAIN PRODUCT FORM
   * ---------------------------------------------------------
   */

  function syncMainProductForm(
    sticky,
    variant
  ) {

    if (!variant) {
      return;
    }


    const form =
      getProductForm(
        sticky.dataset.section
      );


    if (!form) {

      console.warn(
        'Sticky ATC: main product form not found.'
      );

      return;
    }


    const variantInput =
      form.querySelector(
        'input[name="id"]'
      );


    if (!variantInput) {
      return;
    }


    if (
      String(variantInput.value) ===
      String(variant.id)
    ) {
      return;
    }


    variantInput.value =
      variant.id;


    variantInput.dispatchEvent(
      new Event(
        'change',
        {
          bubbles: true
        }
      )
    );
  }


  /*
   * ---------------------------------------------------------
   * UPDATE STICKY BUTTON
   * ---------------------------------------------------------
   */

  function updateStickyButton(
    sticky,
    variant
  ) {

    /*
     * Theme Editor: keep Sticky ATC visible while editing.
     * The storefront still uses the normal after-scroll behavior.
     */
    if (window.Shopify?.designMode) {
      document.documentElement.setAttribute(
        'data-sticky-atc-editor',
        'true'
      );
      sticky.classList.add('is-visible');
    }

    const sectionId =
      sticky.dataset.section;


    const button =
      sticky.querySelector(
        '#SectionAtcBtn-' +
        sectionId
      ) ||

      sticky.querySelector(
        '.main-product-atc'
      );


    if (
      !button ||
      !variant
    ) {
      return;
    }


    /*
     * Availability.
     */

    button.disabled =
      variant.available === false;


    /*
     * Label.
     */

    const label =
      button.querySelector(
        '.sticky-atc__label__text'
      );


    if (label) {

      if (
        variant.available === false
      ) {

        label.textContent =
          'Brak w magazynie';

      } else {

        if (
          !label.dataset.originalText
        ) {

          label.dataset.originalText =
            label.textContent.trim();
        }


        label.textContent =
          label.dataset.originalText ||
          'Dodaj do koszyka';
      }
    }


    /*
     * Price.
     */

    const price =
      sticky.querySelector(
        '#sticky-atc-price-' +
        sectionId
      );


    if (
      price &&
      variant.price != null &&
      window.Shopify?.formatMoney
    ) {

      price.textContent =
        window.Shopify.formatMoney(
          variant.price,
          window.Shopify.money_format ||
          '{{amount_with_comma_separator}}'
        ) + ' •';
    }
  }


  /*
   * ---------------------------------------------------------
   * REFRESH CART DRAWER
   * ---------------------------------------------------------
   */

  async function refreshCartDrawer() {

    const root =
      window.Shopify?.routes?.root ||
      '/';


    const url =
      root +
      '?sections=cart-drawer';


    const response =
      await fetch(
        url,
        {
          headers: {
            'X-Requested-With':
              'XMLHttpRequest',

            'Accept':
              'application/json'
          }
        }
      );


    if (!response.ok) {

      throw new Error(
        'Nie udało się odświeżyć koszyka.'
      );
    }


    const sections =
      await response.json();


    const html =
      sections['cart-drawer'];


    if (!html) {
      return;
    }


    const parser =
      new DOMParser();


    const parsedDocument =
      parser.parseFromString(
        html,
        'text/html'
      );


    const newDrawer =
      parsedDocument.querySelector(
        'cart-drawer'
      );


    const currentDrawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      !newDrawer ||
      !currentDrawer
    ) {
      return;
    }


    const wasOpen =
      currentDrawer.classList.contains(
        'active'
      );


    currentDrawer.replaceWith(
      newDrawer
    );


    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      wasOpen &&
      drawer &&
      typeof drawer.open === 'function'
    ) {

      drawer.open();
    }
  }


  /*
   * ---------------------------------------------------------
   * ADD TO CART
   * ---------------------------------------------------------
   */

  async function addToCart(
    sticky,
    variant
  ) {

    if (!variant) {

      throw new Error(
        'Nie znaleziono wariantu produktu.'
      );
    }


    if (
      variant.available === false
    ) {

      throw new Error(
        'Ten wariant jest niedostępny.'
      );
    }


    const form =
      getProductForm(
        sticky.dataset.section
      );


    /*
     * Quantity from main product form.
     */

    let quantity = 1;


    const quantityInput =
      form?.querySelector(
        'input[name="quantity"]'
      );


    if (quantityInput) {

      quantity =
        parseInt(
          quantityInput.value,
          10
        ) || 1;
    }


    /*
     * Add product.
     */

    const response =
      await fetch(
        '/cart/add.js',
        {
          method: 'POST',

          headers: {
            'Accept':
              'application/json',

            'Content-Type':
              'application/json'
          },

          body:
            JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      variant.id
                    ),

                  quantity:
                    quantity
                }
              ]
            })
        }
      );


    if (!response.ok) {

      const error =
        await response
          .json()
          .catch(
            () => ({})
          );


      throw new Error(
        error.description ||
        error.message ||
        'Nie udało się dodać produktu do koszyka.'
      );
    }


    /*
     * Refresh cart drawer.
     */

    await refreshCartDrawer();


    /*
     * Open drawer.
     */

    const drawer =
      document.querySelector(
        'cart-drawer'
      );


    if (
      drawer &&
      typeof drawer.open === 'function'
    ) {

      drawer.open();
    }
  }


  /*
   * ---------------------------------------------------------
   * STICKY VISIBILITY
   *
   * Logic:
   *
   * 1. At very top:
   *    HIDDEN
   *
   * 2. Main ATC visible:
   *    HIDDEN
   *
   * 3. Main ATC outside viewport:
   *    VISIBLE
   *
   * 4. At very bottom:
   *    HIDDEN
   * ---------------------------------------------------------
   */

  function setupStickyVisibility(sticky, mainButton) {
    if (
      !mainButton ||
      sticky.dataset.afterScroll !== 'true'
    ) {
      return;
    }

    if (sticky._stickyAtcVisibilityInitialized) {
      return;
    }

    sticky._stickyAtcVisibilityInitialized = true;

    // CSS controls the animation. JS only toggles .is-visible.
    sticky.classList.remove('is-visible');

    const BUNDLE_SELECTORS = [
      // Shrine's bundle-offer block.
      '.bundle-offer-container',
      'main-bundle-offer',
      'bundle-deals',

      // Common Pumper / bundle-app hooks. These are intentionally broad
      // only for elements that are actually visible in the viewport.
      '[class*="pumper"]',
      '[id*="pumper"]',
      '[data-pumper]',
      '[data-pumper-bundles]',
      '[data-pumper-bundle]',
      '[class*="bundle-widget"]',
      '[class*="bundle-selector"]',
      '[class*="bundle-offer"]'
    ];

    function getScrollTop() {
      return window.scrollY || window.pageYOffset || 0;
    }

    function isAtTop() {
      // Keep Sticky firmly hidden during the initial product/hero area.
      return getScrollTop() <= 80;
    }

    function isAtBottom() {
      const scrollTop = getScrollTop();
      const viewportHeight = window.innerHeight || 0;
      const documentHeight = Math.max(
        document.body?.scrollHeight || 0,
        document.documentElement?.scrollHeight || 0
      );

      return documentHeight - (scrollTop + viewportHeight) <= 40;
    }

    function isMeaningfullyVisible(rect, viewportHeight) {
      if (!rect || rect.width <= 0 || rect.height <= 0) {
        return false;
      }

      const visibleHeight =
        Math.min(rect.bottom, viewportHeight) -
        Math.max(rect.top, 0);

      return visibleHeight >= Math.min(
        40,
        Math.max(1, rect.height * 0.15)
      );
    }

    function mainButtonIsVisible() {
      return isMeaningfullyVisible(
        mainButton.getBoundingClientRect(),
        window.innerHeight || 0
      );
    }

    function bundleSelectorIsVisible() {
      const viewportHeight = window.innerHeight || 0;

      for (const selector of BUNDLE_SELECTORS) {
        let elements;

        try {
          elements = document.querySelectorAll(selector);
        } catch (error) {
          continue;
        }

        for (const element of elements) {
          // Ignore the sticky element itself and hidden/template nodes.
          if (
            element === sticky ||
            element.closest('sticky-atc') ||
            element.hidden
          ) {
            continue;
          }

          const style = window.getComputedStyle(element);

          if (
            style.display === 'none' ||
            style.visibility === 'hidden' ||
            parseFloat(style.opacity || '1') === 0
          ) {
            continue;
          }

          if (
            isMeaningfullyVisible(
              element.getBoundingClientRect(),
              viewportHeight
            )
          ) {
            return true;
          }
        }
      }

      return false;
    }

    function updateScrollToTopOffset() {
      const buttons = document.querySelectorAll('.scroll-to-top-btn');

      buttons.forEach(button => {
        if (sticky.classList.contains('is-visible')) {
          const height = sticky.getBoundingClientRect().height || 0;
          const gap = 12;
          button.style.setProperty(
            '--sticky-atc-offset',
            `${Math.ceil(height + gap)}px`
          );
        } else {
          button.style.setProperty('--sticky-atc-offset', '0px');
        }
      });
    }

    function updateVisibility() {
      if (
        !document.documentElement.contains(sticky) ||
        !document.documentElement.contains(mainButton)
      ) {
        return;
      }

      const shouldHide =
        isAtTop() ||
        isAtBottom() ||
        mainButtonIsVisible() ||
        bundleSelectorIsVisible();

      if (shouldHide) {
        sticky.classList.remove('is-visible');
      } else {
        sticky.classList.add('is-visible');
      }

      updateScrollToTopOffset();
    }

    let ticking = false;

    function scheduleUpdate() {
      if (ticking) return;

      ticking = true;

      window.requestAnimationFrame(() => {
        updateVisibility();
        ticking = false;
      });
    }

    if (typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(
        () => scheduleUpdate(),
        { threshold: [0, 0.01, 0.5, 1] }
      );

      observer.observe(mainButton);
      sticky._stickyAtcObserver = observer;
    }

    window.addEventListener('scroll', scheduleUpdate, {
      passive: true
    });

    window.addEventListener('resize', scheduleUpdate, {
      passive: true
    });

    // Bundle apps can inject/re-render their widget after page load.
    // Re-check after DOM mutations without creating a second observer.
    if (typeof MutationObserver !== 'undefined') {
      const mutationObserver = new MutationObserver(() => {
        scheduleUpdate();
      });

      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden',
          'data-pumper',
          'data-pumper-bundles',
          'data-pumper-bundle'
        ]
      });

      sticky._stickyAtcMutationObserver = mutationObserver;
    }

    // Initial state: definitely hidden at the top.
    updateVisibility();
  }

  /*
   * ---------------------------------------------------------
   * INITIALIZE STICKY ATC
   * ---------------------------------------------------------
   */

  function initStickyATC(
    sticky
  ) {

    if (
      !sticky ||
      sticky.dataset.standaloneInitialized ===
      'true'
    ) {
      return;
    }


    sticky.dataset.standaloneInitialized =
      'true';


    const sectionId =
      sticky.dataset.section;


    /*
     * -------------------------------------------------------
     * FIND MAIN PRODUCT FORM
     * -------------------------------------------------------
     */

    const form =
      getProductForm(
        sectionId
      );


    /*
     * -------------------------------------------------------
     * FIND MAIN ATC BUTTON
     * -------------------------------------------------------
     */

    const mainButton =
      form?.querySelector(
        '#ProductSubmitButton-' +
        sectionId
      ) ||

      form?.querySelector(
        'button[type="submit"]'
      );


    /*
     * -------------------------------------------------------
     * STICKY VISIBILITY
     * -------------------------------------------------------
     */

    setupStickyVisibility(
      sticky,
      mainButton
    );


    /*
     * -------------------------------------------------------
     * VARIANT PICKER
     * -------------------------------------------------------
     */

    const picker =
      sticky.querySelector(
        'secondary-variant-select, secondary-variant-select-separate'
      );


    if (picker) {

      /*
       * Custom picker change.
       */

      picker.addEventListener(
        'change',
        () => {

          const variant =
            getStickyVariant(
              sticky
            );


          if (!variant) {
            return;
          }


          syncMainProductForm(
            sticky,
            variant
          );


          updateStickyButton(
            sticky,
            variant
          );
        }
      );


      /*
       * Direct select change.
       */

      picker
        .querySelectorAll(
          'select'
        )
        .forEach(
          select => {

            select.addEventListener(
              'change',
              () => {

                const variant =
                  getStickyVariant(
                    sticky
                  );


                if (!variant) {
                  return;
                }


                syncMainProductForm(
                  sticky,
                  variant
                );


                updateStickyButton(
                  sticky,
                  variant
                );
              }
            );
          }
        );
    }


    /*
     * -------------------------------------------------------
     * INITIAL VARIANT
     * -------------------------------------------------------
     */

    const initialVariant =
      getStickyVariant(
        sticky
      );


    if (initialVariant) {

      syncMainProductForm(
        sticky,
        initialVariant
      );


      updateStickyButton(
        sticky,
        initialVariant
      );
    }


    /*
     * -------------------------------------------------------
     * STICKY ADD TO CART BUTTON
     * -------------------------------------------------------
     */

    const button =
      sticky.querySelector(
        '#SectionAtcBtn-' +
        sectionId
      ) ||

      sticky.querySelector(
        '.main-product-atc'
      );


    if (!button) {

      console.warn(
        'Sticky ATC: Sticky Add To Cart button not found.',
        sticky
      );

      return;
    }


    /*
     * -------------------------------------------------------
     * BUTTON CLICK
     * -------------------------------------------------------
     */

    button.addEventListener(
      'click',
      async event => {

        event.preventDefault();
        event.stopPropagation();


        if (button.disabled) {
          return;
        }


        const variant =
          getStickyVariant(
            sticky
          );


        if (!variant) {

          console.error(
            'Sticky ATC: variant not found.'
          );

          return;
        }


        /*
         * Synchronize main form.
         */

        syncMainProductForm(
          sticky,
          variant
        );


        /*
         * Loading state.
         */

        button.disabled =
          true;


        button.classList.add(
          'loading'
        );


        try {

          await addToCart(
            sticky,
            variant
          );

        } catch (error) {

          console.error(
            'Sticky ATC:',
            error
          );


          const errorElement =
            button.querySelector(
              '.sticky-atc__error'
            );


          if (errorElement) {

            errorElement.textContent =
              error.message;


            errorElement.style.display =
              'inline';
          }

        } finally {

          button.classList.remove(
            'loading'
          );


          /*
           * Recalculate availability.
           */

          const currentVariant =
            getStickyVariant(
              sticky
            );


          button.disabled =
            currentVariant?.available ===
            false;
        }
      }
    );
  }


  /*
   * ---------------------------------------------------------
   * INITIALIZE EXISTING STICKY ATCS
   * ---------------------------------------------------------
   */

  function initialize() {

    document
      .querySelectorAll(
        'sticky-atc'
      )
      .forEach(
        sticky => {

          try {

            initStickyATC(
              sticky
            );

          } catch (error) {

            console.error(
              'Sticky ATC initialization error:',
              error
            );
          }
        }
      );
  }


  /*
   * ---------------------------------------------------------
   * INITIAL RUN
   * ---------------------------------------------------------
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );

  } else {

    initialize();
  }


  /*
   * ---------------------------------------------------------
   * SHOPIFY DYNAMIC SECTION SUPPORT
   * ---------------------------------------------------------
   */

  const mutationObserver =
    new MutationObserver(
      mutations => {

        let shouldInitialize =
          false;


        for (
          const mutation of mutations
        ) {

          if (
            mutation.addedNodes &&
            mutation.addedNodes.length
          ) {

            shouldInitialize =
              true;

            break;
          }
        }


        if (
          shouldInitialize
        ) {

          initialize();
        }
      }
    );


  if (document.body) {

    mutationObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  } else {

    document.addEventListener(
      'DOMContentLoaded',
      () => {

        mutationObserver.observe(
          document.body,
          {
            childList: true,
            subtree: true
          }
        );
      }
    );
  }

})();
